import React from 'react'
import gardencafe from "../images/Garden_cafe.jpg";
import vasntaori from "../images/vasantori_cafe.jpg";
import vasantoriphoto from "../images/vasantaori_side view Berhampore.jpg";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import couplezone from "../images/couple zone.jpg";
import cafearea from "../images/cafe zone.jpg";
import canopy from "../images/FLOATING CANOPY.jpg"

function Vintagemorep() {
  return (
    <div>
           <div className='album py-0'>
                <div className='container'>
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                                <Zoom>
                                <img src={gardencafe} className="card-img-top imge2" alt="gardencafe"/>
                                </Zoom>
                                <div className="overlay1"> CAFE GARDEN AREA </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1">
                          <Zoom>
                                <img src={vasntaori} className="card-img-top image2" alt="vasntaori"/>
                                </Zoom>
                               
                                <div className="overlay1">VASANTORI VIEW </div>
                            </div>
                        </div>
                   
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={vasantoriphoto} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">VASANTORI VIEW </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={couplezone} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">COUPLE ZONE</div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={cafearea} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">COUPLE CAFE ZONE </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="restaurant hoverimage1" >
                          <Zoom>
                                 <img src={canopy} className="card-img-top image2" alt="Vila's Club Resort"/>
                                 </Zoom>
                               
                                 <div className="overlay1">FLOATING CANOPY </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
    </div>
  )
}

export default Vintagemorep